/* eslint-disable max-len */
const scriptByBrandId = {
  '08b5230e-8541-41f1-a776-5644bdfd4b40': {
    code: `
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){ (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o), m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m) })(window,document,'script','//www.google-analytics.com/analytics.js','krwnGA');
      krwnGA('create', 'UA-84932343-1','auto', {'allowLinker': true});
      krwnGA('require', 'linker');
      krwnGA('linker:autoLink', ['krwn.co'] );
      krwnGA('send', 'pageview');
    `,
    dispose: () => {
      window.krwnGA = function gaNoop() {};
    },
  },
  'a9582d57-553c-4a99-8a68-05958923f2ef': {
    code: `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','kingsDataLayer','GTM-5QV4TND');
    `,
    dispose: () => {
      window.kingsDataLayer = [];
    },
  },
  'cce706a3-c15a-4728-9d81-f2f8d8e57172': {
    code: `
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=AW-10926152046' + '&l=stylzDataLayer';
      document.head.appendChild(s);
      
      window.stylzDataLayer = window.stylzDataLayer || [];
      function stylzGtag(){stylzDataLayer.push(arguments);}
      stylzGtag('js', new Date());
    
      stylzGtag('config', 'AW-10926152046');
    `,
    dispose: () => {
      window.stylzGtag = function stylzGtag() {
        return null;
      };
      window.stylzDataLayer = [];
    },
  },
};

// eslint-disable-next-line import/prefer-default-export
export const getTrackingScript = brandId => scriptByBrandId[brandId];



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/gtag/helpers.js